// extracted by mini-css-extract-plugin
export default {"wrapper":"yRiLd6","content":"KFP75E","inner-wrapper":"igyYt4","innerWrapper":"igyYt4","font-ruler-content":"EdURKq","fontRulerContent":"EdURKq"};